// Durée estimée d'une séance (modèle TIME_MODEL) et calibration sur les séances réellement chronométrées.
// --- TEMPS DE RÉVISION ESTIMÉ ---
// J0 : écoute du podcast (durée réelle s'il existe, sinon ≈ mots de la fiche / 165) + une dizaine de QCM + rédaction
// d'une fiche personnelle sur iPad (≈ mots / 80). J suivants : dizaine de QCM + active recall + relecture partielle de
// la fiche sur erreur. J30+ et Loop : QCM de brassage. Les coefficients sont regroupés ici pour être ajustés.
window.TIME_MODEL = { qcmCount: 10, qcmMinPerQuestion: 1.5, recallMin: 10, rereadFactor: 0.3, ficheWriteWordsPerMin: 80, podcastWordsPerMin: 165, explicatifFactor: 1.6, brassageMin: 15 };
window.taskWords = function(task) {
    var n = String(task.baseItemId || task.itemId), fd = window.getFicheData(n);
    var words = fd && fd.w ? fd.w : 0;
    if (!words) return 0;
    var sc = window.taskPodcastScope(task);
    if (sc.part) {
        var fs = window.FICHE_STRUCTURE && window.FICHE_STRUCTURE[n];
        var pn = (fs && fs.tree && window.fichePartNodes) ? window.fichePartNodes(n, fs.tree, sc.part) : null;
        if (pn && pn.w) return pn.w;
        var parts = window.state.subParts[n];
        return Math.round(words / Math.max(1, parts ? parts.length : 2));
    }
    return words;
};
window.estimateTaskMinutes = function(task) {
    var M = window.TIME_MODEL, words = window.taskWords(task), parts = [], qcm = Math.round(M.qcmCount * M.qcmMinPerQuestion);
    var day = task.type === 'Loop' ? 999 : parseInt(String(task.type).replace('J', ''), 10);
    if (isNaN(day)) day = 7;
    if (day === 0) {
        var sc = window.taskPodcastScope(task), pc = window.podcastFor(sc.n, sc.part, sc.pedia, !!window.state.podcastExplicatif) || window.podcastFor(sc.n, sc.part, sc.pedia, !window.state.podcastExplicatif);
        var pod = pc && pc.duration ? Math.max(1, Math.round(pc.duration / 60)) : (words ? Math.max(3, Math.round(words / M.podcastWordsPerMin * (window.state.podcastExplicatif ? M.explicatifFactor : 1))) : 10);
        var fiche = words ? Math.max(5, Math.round(words / M.ficheWriteWordsPerMin)) : 15;
        // la fiche iPad s'écrit pendant l'écoute : on compte le plus long des deux
        parts.push({ label: 'Podcast' + (pc && pc.duration ? '' : ' (estimé)') + ' ' + pod + ' min + fiche iPad ' + fiche + ' min en parallèle', min: Math.max(pod, fiche) });
        parts.push({ label: M.qcmCount + ' QCM', min: qcm });
    } else if (day >= 30) {
        parts.push({ label: 'QCM de brassage', min: M.brassageMin });
    } else {
        parts.push({ label: M.qcmCount + ' QCM', min: qcm });
        parts.push({ label: 'Active recall', min: M.recallMin });
        var reread = words ? Math.max(2, Math.round(words / 130 * M.rereadFactor)) : 5;
        parts.push({ label: 'Relecture fiche (sur erreur)', min: reread });
    }
    var raw = parts.reduce(function(a, p) { return a + p.min; }, 0);
    var cal = window.timeCalibration()[window.timeCategory(task)];
    var reel = window.tempsReel(task); // tes séances d'abord, le modèle sinon
    if (reel) return { total: reel.min, raw: raw, parts: parts, factor: cal.factor, samples: cal.n, reel: reel };
    return { total: Math.max(1, Math.round(raw * cal.factor)), raw: raw, parts: parts, factor: cal.factor, samples: cal.n, reel: null };
};
// --- CALIBRATION SUR TES SÉANCES RÉELLES ---
// Chaque tâche a un chronomètre (démarré à la main, ou automatiquement quand tu lances son podcast ou une session de
// QCM) ; le cocher « fait » enregistre la durée réelle avec l'estimation du modèle (journal d'apprentissage, serveur).
// Par catégorie (J0 / révisions / brassage), le facteur = médiane des rapports réel ÷ estimé sur les 30 dernières
// séances (au moins 3), borné entre 0,4 et 3 : les estimations suivent tes habitudes et la longueur des fiches.
window.timeCategory = function(task) { var d = task.type === 'Loop' ? 999 : parseInt(String(task.type).replace('J', ''), 10); return d === 0 ? 'j0' : (isNaN(d) || d < 30 ? 'rev' : 'brass'); };
window.timeCalibration = function() {
    var log = (window.state.learning && window.state.learning.log) || [], by = { j0: [], rev: [], brass: [] };
    log.forEach(function(e) { if (e.m === 'time' && e.est > 0 && e.min > 0 && by[e.cat]) by[e.cat].push(e); });
    var out = {};
    Object.keys(by).forEach(function(c) {
        var arr = by[c].sort(function(a, b) { return a.t - b.t; }).slice(-30).map(function(e) { return e.min / e.est; }).sort(function(a, b) { return a - b; });
        var f = 1; if (arr.length >= 3) { var mid = Math.floor(arr.length / 2); f = arr.length % 2 ? arr[mid] : (arr[mid - 1] + arr[mid]) / 2; f = Math.min(3, Math.max(0.4, f)); }
        out[c] = { factor: Math.round(f * 100) / 100, n: arr.length };
    });
    return out;
};
// --- TES SÉANCES D'ABORD : la durée affichée vient de ce que TU as réellement mis --------------------------------
// J0 : médiane de tes séances J0 sur des fiches de longueur comparable (± 25 % de mots ; au moins 3 séances, sinon
// les 5 plus proches en longueur). Révision (J > 0, Loop) : le temps de ta DERNIÈRE révision de cet item ; à défaut,
// la médiane de tes révisions sur des fiches comparables. Sans séance chronométrée : le modèle ci-dessus, calibré.
window.tempsSeances = function() {
    var log = (window.state.learning && window.state.learning.log) || [];
    return log.filter(function(e) { return e.m === 'time' && e.min > 0; });
};
window.mediane = function(arr) {
    if (!arr.length) return null;
    var a = arr.slice().sort(function(x, y) { return x - y; }), m = Math.floor(a.length / 2);
    return a.length % 2 ? a[m] : (a[m - 1] + a[m]) / 2;
};
window.tempsReel = function(task) {
    var seances = window.tempsSeances(); if (!seances.length) return null;
    var cat = window.timeCategory(task), words = window.taskWords(task), base = String(task.baseItemId || task.itemId), ped = !!window.isPediaTask(task);
    if (cat !== 'j0') {
        var dern = null;
        seances.forEach(function(e) { if (String(e.i) === base && e.cat !== 'j0' && !!e.pedia === ped && (!dern || e.t > dern.t)) dern = e; });
        if (dern) return { min: Math.max(1, Math.round(dern.min)), source: 'item', n: 1, quand: dern.t };
    }
    if (!words) return null;
    var memeCat = seances.filter(function(e) { return e.cat === cat && e.words > 0; });
    if (!memeCat.length) return null;
    var proches = memeCat.filter(function(e) { return Math.abs(e.words - words) <= words * 0.25; });
    if (proches.length < 3) proches = memeCat.slice().sort(function(a, b) { return Math.abs(a.words - words) - Math.abs(b.words - words); }).slice(0, 5);
    var med = window.mediane(proches.map(function(e) { return e.min; }));
    if (med == null) return null;
    var mots = proches.map(function(e) { return e.words; });
    return { min: Math.max(1, Math.round(med)), source: 'similaires', n: proches.length, mots: [Math.min.apply(null, mots), Math.max.apply(null, mots)] };
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const TIME_MODEL = window.TIME_MODEL;
export const taskWords = window.taskWords;
export const estimateTaskMinutes = window.estimateTaskMinutes;
export const timeCategory = window.timeCategory;
export const timeCalibration = window.timeCalibration;
export const tempsSeances = window.tempsSeances;
export const mediane = window.mediane;
export const tempsReel = window.tempsReel;
